import classNames from 'classnames'
import { useRef, useState } from 'react'
import Tooltip from './Tooltip'

interface TruncatedTooltipTextProps {
  text: string
  className?: string
  containerClassName?: string
}

const TruncatedTooltipText = ({
  text,
  className,
  containerClassName
}: TruncatedTooltipTextProps) => {
  const textRef = useRef<HTMLSpanElement | null>(null)
  const [isOpen, setIsOpen] = useState(false)

  const handleMouseEnter = () => {
    const element = textRef.current
    if (!element) return

    const isTruncated =
      element.scrollWidth > element.clientWidth ||
      element.scrollHeight > element.clientHeight

    if (isTruncated) {
      setIsOpen(true)
    }
  }

  const handleMouseLeave = () => {
    setIsOpen(false)
  }

  return (
    <Tooltip
      content={text}
      open={isOpen}
      containerTag="span"
      containerClassName={classNames('min-w-0 block', containerClassName)}
    >
      <span
        ref={textRef}
        className={classNames('block truncate', className)}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        {text}
      </span>
    </Tooltip>
  )
}

export default TruncatedTooltipText
